import axios from "axios";

const api = axios.create({
  baseURL: "/api",
  timeout: 10000, // Timeout dalam 10 detik agar tidak loading selamanya
  headers: {
    Accept: "application/json",
  },
});

// attach token otomatis
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// auto logout kalau 401
api.interceptors.response.use(
  (response) => response,

  (error) => {

    const status = error.response?.status;
    const message = error.response?.data?.message;

    const publicPaths = ["/login", "/register", "/admin/login"];
    const isPublicPage = publicPaths.some(
      (path) => window.location.pathname === path
    );

    // auto logout kalau token invalid
    if (status === 401 && !isPublicPage) {

      localStorage.removeItem("token");
      localStorage.removeItem("user");

      window.location.href = "/login";
    }

    // auto logout kalau akun dinonaktifkan
    if (
      status === 403 &&
      message === "Akun telah dinonaktifkan."
    ) {

      localStorage.removeItem("token");
      localStorage.removeItem("user");

      alert("Akun kamu telah dinonaktifkan oleh Administrator");

      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default api;